import { render, staticRenderFns } from "./RiskConferenceSafetyUpdate.vue?vue&type=template&id=6d528282&scoped=true&"
import script from "./RiskConferenceSafetyUpdate.vue?vue&type=script&lang=js&"
export * from "./RiskConferenceSafetyUpdate.vue?vue&type=script&lang=js&"
import style1 from "./RiskConferenceSafetyUpdate.vue?vue&type=style&index=1&id=6d528282&lang=scss&scoped=true&"
import style2 from "./RiskConferenceSafetyUpdate.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d528282",
  null
  
)

export default component.exports